import { getColorScheme } from '../../colors';
export var toolbarMenuDividerStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    var colors = getColorScheme(v.colorScheme);
    return {
      borderTop: "1px solid " + (v.menuDividerBorder || colors.border),
      margin: v.menuDividerMargin,
      alignSelf: 'stretch'
    };
  }
};
//# sourceMappingURL=toolbarMenuDividerStyles.js.map
